import { render } from "./FlightItem.vue?vue&type=template&id=0697db2b"
import script from "./FlightItem.vue?vue&type=script&lang=js"
export * from "./FlightItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__